import { render, staticRenderFns } from "./WardrobeInventory.vue?vue&type=template&id=22977738&"
import script from "./WardrobeInventory.vue?vue&type=script&lang=js&"
export * from "./WardrobeInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports